import React from "react";
// import UserManagementContainer from "../containers/UserManagementContainer";
import UserManagementContainer from "../containers/UserManagement";

const UserManagement = () => {
  return (
    <div>
      <UserManagementContainer />

    </div>
  );
};

export default UserManagement;
